module.exports = require("vuetify/lib/components/VCard");